<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="row mt-2">
                <div class="col-md-12">
                  <button
                    type="submit"
                    @click="handleForm"
                    class="
                      btn btn-primary btn-with-icon-left
                      float-right
                      text-uppercase
                      ml-3
                    "
                  >
                    <i class="material-symbols-outlined">check</i>
                    Simpan Obat
                  </button>
                  <!-- <router-link
                    class="btn btn-outline-danger btn-no-outline float-right"
                    to="/master/obat"
                    >Batalkan</router-link
                  > -->
                  <a
                    class="
                      btn btn-outline-danger btn-no-outline
                      float-right
                      text-uppercase
                    "
                    @click="() => goBack('/master/obat')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  jenisObatOptions,
  golonganObatOptions,
  lokasiObatOptions,
} from "@/data/helper.js";
let data = {
  title: "Obat / Alkes Baru",
  backBtn: "/master/obat",
  actionBtn: [],
  breadcrumb: [
    { title: "Obat / Alkes", link: "/master/obat" },
    { title: "Baru", active: true },
  ],
};

export default {
  name: "ObatForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: [
        {
          colnum: 2,
          columns: [
            {
              name: "jenis",
              type: "select",
              label: "Pilih Jenis Obat / Alkes",
              options: jenisObatOptions,
            },
            { name: "kode", type: "text", label: "Kode Obat / Alkes" },
          ],
        },
        {
          colnum: 1,
          columns: [{ name: "nama", type: "text", label: "Nama Obat / Alkes" }],
        },
        {
          colnum: 2,
          columns: [
            {
              name: "harga",
              type: "money",
              label: "Harga per satuan",
              colwidth: 8,
            },
            {
              name: "stok",
              type: "number",
              label: "Jumlah Tersedia ( Stok )",
              colwidth: 4,
            },
          ],
        },
        {
          colnum: 2,
          columns: [
            {
              name: "golongan_obat",
              type: "select",
              label: "Golongan Obat",
              options: golonganObatOptions,
            },
            {
              name: "lokasi",
              type: "select",
              label: "Lokasi Penyimpanan Obat / Alkes",
              options: lokasiObatOptions,
            },
          ],
        },
        {
          colnum: 1,
          columns: [
            {
              name: "ditanggung",
              type: "radio",
              label: "ditanggung",
              options: [
                { label: "Ya", value: "1" },
                { label: "Tidak", value: "0" },
              ],
            },
          ],
        },
      ],
      formSet: {
        ditanggung: "",
        jenis: "",
        kode: "",
        nama: "",
        harga: 0,
        stok: 0,
        lokasi: "",
        golongan_obat: "",
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, self.formSet[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post("obat", formData);
          //console.log(result);
          if (result.status == "200") {
            let result = await this.$store.state.HTTP_SIAKUN.post(
              "produk/tambah-simrs",
              {
                nama: this.formSet.nama,
                kategori: "OBAT",
                kode: this.formSet.kode,
                hargaJual: this.formSet.harga,
                hargaBeli: this.formSet.harga,
                stokBarang: this.formSet.stok,
              }
            );
            //console.log(result);
            if (result.status == "200") {
              //console.log('berhasil menyimpan obat ke siakun');
              this.$router.push(`/master/obat`);
            } else {
              //console.log('Error. Gagal menyimpan obat ke siakun');
            }
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      return valid;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {},
};
</script>
